<template>
  <div class="share">

    <header-bar></header-bar>

    <section>
      <div class="grid-container">
        <div class="col-4">
          <div class="rep-diagram">
            <div class="image-circle">
              <img v-if="this.$root.profile.profileimg === 'default'" src="https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f" />
              <img v-else :src="this.$root.profile.profileimg" />
            </div>
            <h1>=</h1>
            <div class="image-circle">
              <span>+5</span>
            </div>
          </div>
          <p>Invite people that love to make things happen with your unique URL and earn +5 reputation when they sign up.</p>
          
          <input type="text" :value="'https://share.pei.exchange/' + this.$root.profile.slug"/>

          <a :href="'https://www.facebook.com/sharer/sharer.php?u=https%3A//share.pei.exchange/' + this.$root.profile.slug" target="_blank" class="btn btn-square facebook">Invite Over Facebook</a>

          <a :href="'https://twitter.com/home?status=I\'ve%20just%20created%20an%20account%20on%20PEI%20exCHANGE,%20why%20not%20join%20me%20in%20supporting%20African%20development?%20https%3A//share.pei.exchange/' + this.$root.profile.slug" target="_blank" class="btn btn-square twitter">Invite Over Twitter</a>

          <a :href="'mailto:?&subject=Join me on PEI exCHANGE&body=Hello,%0A%0AI\'ve%20just%20created%20an%20account%20on%20PEI%20exCHANGE.%0A%0Ahttps%3A//share.pei.exchange/' + this.$root.profile.slug + '%0A'" target="_blank" class="btn btn-square email">Invite Over Email</a>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { db } from '@/firebase'
import router from '@/router'
import HeaderBar from '@/components/HeaderBar'

export default {
  data () {
    return {
    }
  },
  components: {
    HeaderBar
  },
  methods: {
    stepBack () {
      this.$parent.currentStep--
    },
    progress () {
      let userData = this.userRegData
      let timestamp = Date.now()
      delete userData['.key']

      let focusArea = userData.personality['focus-areas']
      let haveSkills = userData.personality['have-skills']
      let countries = userData.personality['countries']
      let userObj = {[this.$root.user.uid]: true}
      let userSlug = {[userData.slug]: this.$root.user.uid}

      // Add focus areas
      if (focusArea) {
        for (let item in focusArea) {
          db.ref('attributes/focus-areas/' + item + '/users').update(userObj)
        }
      }

      // Add skills
      if (haveSkills) {
        for (let item in haveSkills) {
          db.ref('attributes/skills/' + item + '/users').update(userObj)
        }
      }

      // Add countries
      if (countries) {
        for (let item in countries) {
          db.ref('attributes/countries/' + item + '/users').update(userObj)
        }
      }

      // Add slug
      db.ref('user-meta/slug').update(userSlug)

      let parent = this
      db.ref('users/' + this.$root.user.uid).set(userData, function () {
        // On complete
        console.log('saved')
        db.ref('users-registration/' + parent.$root.user.uid).remove()
        router.push('/matches')
      })

      // Add notification
      db.ref('user-meta/notifications/' + this.$root.user.uid).push({
        from: 'pei',
        content: 'Thanks for signing up! Here\'s +5 rep as a warm welcome!',
        createdAt: timestamp
      })
    }
  },
  firebase: function () {
    return {
      itemData: {
        source: db.ref('attributes/skills/')
      },
      userRegData: {
        source: db.ref('users-registration/' + this.$root.user.uid),
        asObject: true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Share.vue?56a355b4